<template>
  <a-select
    :disabled="disabled"
    mode="multiple"
    :default-value="defaultValue"
    placeholder="请选择助教"
    :default-active-first-option="false"
    :show-arrow="false"
    :filter-option="false"
    :not-found-content="null"
    @change="changeDirectorList"
    @search="getAllDirectorList"
    :loading="loading"
  >
    <a-select-option :value="director.userId" v-for="director in allDirectorList" :key="director.userId">
      {{ director.username }}
    </a-select-option>
  </a-select>
</template>

<script>
import { checkRes } from '@/utils/tool'
import { searchDirector } from '@/server/api/courseManage'
export default {
  name: 'DirectorSelector', // 巡视备注组件
  props: {
    defaultValue: Array,
    disabled: Boolean
  },
  components: {
  },
  data () {
    return {
      loading: false,
      allDirectorList: []
    }
  },
  mounted() {
    this.getAllDirectorList()
  },
  methods: {
    changeDirectorList(value) {
      this.$emit('changeDirectorList', value)
    },
    async getAllDirectorList(value = '') {
      const self = this
      self.loading = true
      const res = await searchDirector({
        keywords: value
      })
      checkRes({
        res,
        success(data) {
          self.allDirectorList = data.rt
        }
      })
      self.loading = false
    }
  }
}
</script>

<style lang="scss" scoped>

</style>